import React from 'react';

export default class Select extends React.Component {

  constructor(props) {
    super(props);
    this.fieldName = props.fieldName;
    this.options = props.options;
    this.value = props.value;
    this.onChange = props.onChange;
	this.state = {
		checked: props.value
	}
  }

  render() {
    let optionsNodes = this.options.map((option) => {
      	let key = this.fieldName + "-" + option.value;
		return (
			<label className="event-list-form__label" key={key}>
				{option.label}
				<input
					type="radio"
					id={option.value}
					value={option.value}
					name={this.fieldName}
					checked={this.state.checked === option.value}
					onChange={(e) => this.state.checked = e.target.value}
				/>
				<span className="event-list-form__radio-button"></span>
			</label>
		);
    });

    return (
      <div id={this.props.id} name={this.fieldName} onChange={this.onChange} defaultValue={this.value}>
        {optionsNodes}
      </div>
    );
  }
}
